import { AxiosError } from 'axios';
import { useState } from 'react';

import { ILocumJobs } from '../../../../models/dashboard/jobs/getLocumJobs.model';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../../../models/https';
import { invitedSingleJobsActions } from '../../../../redux/slices/invitedSingleJobSlice';
import { useAppDisPatch } from '../../../../redux/store';
import useHttps from '../../../useHttps';

const useGetSingleInvitedJob = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDisPatch();

  const onGetSingleInvitedJobError = (err: AxiosError<ErrorHttpResponse>) => {
    console.error(
      err?.message ?? 'Something went wrong while fetching invited job'
    );
  };

  const onGetSingleInvitedJobSuccess =
    (jobId: string) =>
    ({ data }: SuccessHttpResponse<ILocumJobs>) => {
      dispatch(
        invitedSingleJobsActions.getInvitedSingleJob({ jobId, jobData: data })
      );
    };

  const getSingleInvitedJob = (jobId: string) => {
    const url: HttpConfig = {
      url: `jobs-service/jobs/${jobId}`,
      method: 'get',
    };

    return request(
      url,
      onGetSingleInvitedJobSuccess(jobId),
      setLoading,
      onGetSingleInvitedJobError
    );
  };

  return { getSingleInvitedJob, loading };
};

export default useGetSingleInvitedJob;
